import { StaticImageData } from 'next/image'

import {
  AhmadImage,
  DougImage,
  JohnImage,
  NatalieImage,
  PaulImage,
  PeterImage,
  RachelImage,
} from 'Assets/Images/Sections/LearnSection'

export enum LearnSectionGalleryItemId {
  Ahmad = 'Ahmad',
  Paul = 'Paul',
  John = 'John',
  Peter = 'Peter',
  Rachel = 'Rachel',
  Doug = 'Doug',
  Natalie = 'Natalie',
}

export type LearnSectionGalleryItem = {
  id: LearnSectionGalleryItemId
  image: StaticImageData
  name: string
  caption: string
  mobileOrder: number
  desktopOrder: number
}

export const ACCESS_SECTION_GALLERY_ITEMS: LearnSectionGalleryItem[] = [
  {
    id: LearnSectionGalleryItemId.Ahmad,
    image: AhmadImage,
    name: 'Ahmad Imam',
    caption: 'Global Influencer\n1M LinkedIn followers',
    mobileOrder: 2,
    desktopOrder: 1,
  },
  {
    id: LearnSectionGalleryItemId.Paul,
    image: PaulImage,
    name: 'Paul Graham',
    caption: 'CEO Australia Post',
    mobileOrder: 2,
    desktopOrder: 2,
  },
  {
    id: LearnSectionGalleryItemId.John,
    image: JohnImage,
    name: 'John Mattick',
    caption: 'Professor and\nWorld-Renowned Geneticist ',
    mobileOrder: 2,
    desktopOrder: 3,
  },
  {
    id: LearnSectionGalleryItemId.Peter,
    image: PeterImage,
    name: 'Peter Gould',
    caption: 'CEO\nOkay Bears NFT',
    mobileOrder: 2,
    desktopOrder: 4,
  },
  {
    id: LearnSectionGalleryItemId.Rachel,
    image: RachelImage,
    name: 'Rachel Powell',
    caption: 'CEO of Magentus',
    mobileOrder: 2,
    desktopOrder: 5,
  },
  {
    id: LearnSectionGalleryItemId.Doug,
    image: DougImage,
    name: 'Doug Jones',
    caption: 'CEO Metcash',
    mobileOrder: 1,
    desktopOrder: 6,
  },
  {
    id: LearnSectionGalleryItemId.Natalie,
    image: NatalieImage,
    name: 'Natalie Cook',
    caption: 'Olympic Gold Medallist ',
    mobileOrder: 2,
    desktopOrder: 7,
  },
]
